import { useFeatureFlag } from '@mews/framework';
import { FeatureFlag } from '@mews-commander/enums';
import { ProcessPaymentType } from '../ProcessPaymentType';
import { DISABLED_PROCESS_PAYMENT_TYPES } from '../const';
import { processPaymentTypeCardGroupMap } from './utils';
import { useGetPaymentTypesEnabledSettingSuspense } from './useGetPaymentTypesEnabledSettingSuspense';

interface GetChargeGuestOptions {
    accountId: string;
    allowedPaymentTypes: ProcessPaymentType[];
}

export const useGetChargeGuestOptionsSuspense = ({ accountId, allowedPaymentTypes }: GetChargeGuestOptions) => {
    const chargeGuestPaymentTypes = [
        ProcessPaymentType.GatewayPayment,
        ProcessPaymentType.MewsTerminalPayment,
        ProcessPaymentType.PaymentRequest,
        ProcessPaymentType.TokenizeCard,
        ProcessPaymentType.GatewayCardPreauth,
        ProcessPaymentType.MewsTerminalPreauth,
    ];
    const paymentTypesEnabledSetting = useGetPaymentTypesEnabledSettingSuspense({ accountId });
    const isPciProxyMaintenanceDisabledPaymentsEnabled = useFeatureFlag(
        FeatureFlag.pciProxyMaintenanceDisabledPaymentsEnabled
    );

    return chargeGuestPaymentTypes
        .filter((paymentType) => allowedPaymentTypes.includes(paymentType) && paymentTypesEnabledSetting[paymentType])
        .map((paymentType) => ({
            ...processPaymentTypeCardGroupMap[paymentType],
            disabled:
                isPciProxyMaintenanceDisabledPaymentsEnabled && DISABLED_PROCESS_PAYMENT_TYPES.includes(paymentType),
        }));
};
